// extracted by mini-css-extract-plugin
export var equalColumn = "_jy-0";